import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Misc from 'src/utils/helper/misc'

export default {
  namespaced: true,

  state () {
    return {
      tags: [],
      minLength: 2,
      excludeChar: ','
    }
  },

  getters: {
    list: state => {
      return state.tags
    },
    minLength: state => {
      return state.minLength
    },
    excludeChar: state => {
      return state.excludeChar
    }
  },

  mutations: {
    add (state, tags) {
      for (const tag of tags) {
        state.tags.push(tag)
      }
    },
    clear (state) {
      state.tags = []
    }
  },

  actions: {
    get ({ commit, state }, options = {}) {
      return new Promise((resolve, reject) => {
        const isValid = Misc.validateScriptRegex(options.name)
        if (!isValid) {
          const err = Errors.create(Misc.scriptErrorObj())
          commit('errors/add', err)
          reject(new Error('Cross scripting error'));
          return false
        }
      })
    },
    clear ({ commit }) {
      commit('clear')
    }
  },

  modules: {
    errors: VuexErrors
  }
}
